import { render } from "./TranslationProgressTags.vue?vue&type=template&id=46a55394&ts=true"
import script from "./TranslationProgressTags.vue?vue&type=script&lang=ts"
export * from "./TranslationProgressTags.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__